import { createFileRoute } from '@tanstack/react-router'
import { BillingReadonlyCallout } from '~/features/billing/componentsV2'
import { PlanSelection } from '~/features/billing/componentsV2/PlanSelection'
import { useBillingInfo } from '~/hooks/billing/useBillingInto'

export const Route = createFileRoute('/workspaces/$workspaceId/billing/plans')({
  component: () => {
    return <Component />
  },
})

function Component() {
  const { workspaceId } = Route.useParams()
  const { billingReadonly } = useBillingInfo(workspaceId) ?? { billingReadonly: false }

  return (
    <>
      {billingReadonly && <BillingReadonlyCallout />}
      <PlanSelection workspaceId={workspaceId} isDialog={false} />
    </>
  )
}
